import { LocationTwoAttributes, SubRouteAttributes } from "@albatrosdeveloper/ave-models-package";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import { CommonModule } from "@angular/common";
import { Component, AfterViewInit, ViewChild } from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormControl, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule, MatPaginatorIntl } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { IRequestResult } from "app/common/interfaces";
import { ExportFileFormat, ExportRange } from "app/layout/export-overlay";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { BusinessPartnerService } from "app/modules/components/business-partners/business-partner/business-partner.service";
import { BusinessPartnerAddressExport } from "app/modules/components/business-partners/business-partner/exports/business-partner-address.export";
import { LocationTwoService } from "app/modules/components/locations/location-two/location-two.service";
import { RouteAreaService } from "app/modules/components/routing/route-area/route-area.service";
import { RouteService } from "app/modules/components/routing/route/route.service";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { debounceTime, distinctUntilChanged, ReplaySubject, Subject, take, takeUntil } from "rxjs";


@Component({
    selector: "app-geo",
    standalone: true,
    templateUrl: "./geo.component.html",
    //    styleUrl: "./geo.component.scss",
    imports: [
        CommonModule,
        MatTableModule,
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSortModule,
        MatPaginatorModule,
        MatIcon,
        MatSlideToggle,
        MatSelectModule,
        MatOptionModule,
        MatTooltipModule,
        MatExpansionModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatRowDef,
        MatSidenav,
        MatSidenavContainer,
        FormsModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
        MatSelectModule,
        MatTabsModule,
        TranslocoModule,
        NgxMatSelectSearchModule,
        MonedaPipe,
        MatDividerModule,
        MatRadioModule,
        MatCheckbox
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
        BusinessPartnerAddressExport,
    ],
})
export class GeoComponent implements AfterViewInit {

    getCode = getCode;

    searchQuery: string = "";
    totalItems: number = 0;
    pageSize: number = 50;
    pageIndex: number = 1;

    dataSource: BusinessPartnerAttributes[] = [];

    /** control for the selected route for multi-selection */
    public routeMultiCtrl: FormControl<RouteAttributes[]> = new FormControl<
        RouteAttributes[]
    >([]);

    /** control for the MatSelect filter keyword multi-selection */
    public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
        ""
    );

    /** list of route filtered by search keyword */
    public filteredRoutes: ReplaySubject<RouteAttributes[]> = new ReplaySubject<
        RouteAttributes[]
    >(1);

    /** local copy of filtered route to help set the toggle all checkbox state */
    protected filteredRouteCache: RouteAttributes[] = [];

    /** flags to set the toggle all checkbox state */
    isIndeterminate = false;
    isChecked = false;

    protected _onDestroy = new Subject<void>();
    routeList: RouteAttributes[] = [];
    routeAreaList: RouteAreaAttributes[] = [];
    locationTwoList: LocationTwoAttributes[] = [];
    subRouteList: SubRouteAttributes[] = [];


    /** control for the selected routeArea for multi-selection */
    public routeAreaMultiCtrl: FormControl<RouteAreaAttributes[]> =
        new FormControl<RouteAreaAttributes[]>([]);

    /** control for the MatSelect filter keyword multi-selection */
    public routeAreaMultiFilterCtrl: FormControl<string> =
        new FormControl<string>("");

    /** list of routeArea filtered by search keyword */
    public filteredRouteAreas: ReplaySubject<RouteAreaAttributes[]> =
        new ReplaySubject<RouteAreaAttributes[]>(1);

    /** local copy of filtered routeArea to help set the toggle all checkbox state */
    protected filteredRouteAreaCache: RouteAreaAttributes[] = [];


    /** Ciudad*/
    /** control for the selected route for multi-selection */
    public locationTwoMultiCtrl: FormControl<LocationTwoAttributes[]> = new FormControl<
        LocationTwoAttributes[]
    >([]);

    /** control for the MatSelect filter keyword multi-selection */
    public locationTwoMultiFilterCtrl: FormControl<string> = new FormControl<string>(
        ""
    );

    /** list of route filtered by search keyword */
    public filteredLocationTwo: ReplaySubject<LocationTwoAttributes[]> = new ReplaySubject<
        LocationTwoAttributes[]
    >(1);

    /** local copy of filtered route to help set the toggle all checkbox state */
    protected filteredLocationTwoCache: LocationTwoAttributes[] = [];

    /** flags to set the toggle all checkbox state */
    isIndeterminateTwo = false;
    isCheckedTwo = false;

        /** SubRoute*/
    /** control for the selected route for multi-selection */
    public subRouteMultiCtrl: FormControl<SubRouteAttributes[]> = new FormControl<
        SubRouteAttributes[]
    >([]);

    /** control for the MatSelect filter keyword multi-selection */
    public subRouteMultiFilterCtrl: FormControl<string> = new FormControl<string>(
        ""
    );

    /** list of route filtered by search keyword */
    public filteredSubRoute: ReplaySubject<SubRouteAttributes[]> = new ReplaySubject<
        SubRouteAttributes[]
    >(1);

    /** local copy of filtered route to help set the toggle all checkbox state */
    protected filteredSubRouteCache: SubRouteAttributes[] = [];

    /** flags to set the toggle all checkbox state */
    isIndeterminateSub = false;
    isCheckedSub = false;

    
    businessPartnerList: BusinessPartnerAttributes[] = [];
    searchBusiness = ''
    private searchSubjectBusiness = new Subject<string>();

      /** control for the selected route for multi-selection */
    public businessPartners: FormControl<BusinessPartnerAttributes[]> = new FormControl<
        BusinessPartnerAttributes[]
    >([]);

    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        private readonly routeAreaService: RouteAreaService,
        private readonly routeService: RouteService,
        private readonly locationtwo: LocationTwoService,
        private readonly subRouteService: SubRouteService,
        private readonly businessService: BusinessPartnerService,
        private businessPartnerAddressExport: BusinessPartnerAddressExport,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.fetchAllRutas();
        this.fetchRouteArea();
        this.fetchLocationTwo();
        this.fetchSubRoute();
        this.setupBusinessSearchControl();
    }

    ngAfterViewInit() {
    }

    changueOptionsBusiness(event) {
        this.searchSubjectBusiness.next(event)
    }

    private setupBusinessSearchControl(): void {
        this.searchSubjectBusiness
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((searchTerm) => {
                if (searchTerm) {
                    this.searchBusiness = searchTerm;
                    this.getAllBusinessPartner();
                }
            });
    }

    
      private getAllBusinessPartner(): void {
        const materialOptions = {
          search: this.searchBusiness ? this.searchBusiness: null,
          currentPage: 1,
          limitPerPage: 50,
          sortActive: "name",
          //sortDirection: "ASC"
        };
    
        this.businessService.findToComboBoxCustomer(
          materialOptions,
          [],
          []
        ).subscribe({
          next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
            this.businessPartnerList = res?.data ?? [];
          },
          error: (err) => {
            this.snackBar.open(err.error.message || "Error al obtener socios de negocios.","Cerrar",{ duration: 5000});
          },
        })
      }


    private fetchAllRutas(): void {
        this.routeService.findToComboBox().subscribe({
            next: (res) => {
                this.routeList = res.data;
                this.filteredRoutes.next(this.routeList);

                // listen for search field value changes
                this.routeMultiFilterCtrl.valueChanges
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => {
                        this.filterRouteMulti();
                        this.setToggleAllCheckboxState();
                    });
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener territorios.","Cerrar",{ duration: 5000});
            },
        });
    }

    protected filterRouteMulti() {
        if (!this.routeList) {
            return;
        }
        // get the search keyword
        let search = this.routeMultiFilterCtrl.value;
        if (!search) {
            this.filteredRouteCache = this.routeList;
            this.filteredRoutes.next(this.routeList);
            return;
        } else {
            search = search.toLowerCase();
        }
        // Filtrar las rutas por nombre o código
        this.filteredRouteCache = this.routeList.filter((material) => {
            const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
            const codeMatches =
                material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
            return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
        });
        this.filteredRoutes.next(this.filteredRouteCache);
    }

    protected setToggleAllCheckboxState() {
        let filteredLength = 0;
        if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
            this.filteredRouteCache.forEach((el) => {
                if (this.routeMultiCtrl.value.indexOf(el) > -1) {
                    filteredLength++;
                }
            });
            this.isIndeterminate =
                filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
            this.isChecked =
                filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
        }
    }


    toggleSelectAll(selectAllValue: boolean) {
        this.filteredRoutes
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe((val) => {
                if (selectAllValue) {
                    this.routeMultiCtrl.patchValue(val);
                } else {
                    this.routeMultiCtrl.patchValue([]);
                }
            });
    }


    private fetchRouteArea(): void {
        this.routeAreaService.findToComboBox().subscribe({
            next: (res) => {
                this.routeAreaList = res.data;
                this.filteredRouteAreas.next(this.routeAreaList);
                // listen for search field value changes
                this.routeAreaMultiFilterCtrl.valueChanges
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => {
                        this.filterRoutereAreaMulti();
                        this.setToggleAllCheckboxStateRouteArea();
                    });
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener areas de rutas.","Cerrar",{ duration: 5000});
            },
        });
    }


    protected filterRoutereAreaMulti() {
        if (!this.routeAreaList) {
            return;
        }
        // get the search keyword
        let search = this.routeAreaMultiFilterCtrl.value;
        if (!search) {
            this.filteredRouteAreaCache = this.routeAreaList;
            this.filteredRouteAreas.next(this.routeAreaList);
            return;
        } else {
            search = search.toLowerCase();
        }
        // Filtrar las rutas por nombre o código
        this.filteredRouteAreaCache = this.routeAreaList.filter((material) => {
            const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
            const codeMatches =
                material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
            return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
        });
        this.filteredRouteAreas.next(this.filteredRouteAreaCache);
    }

    toggleSelectAllRouteArea(selectAllValue: boolean) {
        this.filteredRouteAreas
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe((val) => {
                if (selectAllValue) {
                    this.routeAreaMultiCtrl.patchValue(val);
                } else {
                    this.routeAreaMultiCtrl.patchValue([]);
                }
            });
    }
    protected setToggleAllCheckboxStateRouteArea() {
        let filteredLength = 0;
        if (this.routeAreaMultiCtrl && this.routeAreaMultiCtrl.value) {
            this.filteredRouteAreaCache.forEach((el) => {
                if (this.routeAreaMultiCtrl.value.indexOf(el) > -1) {
                    filteredLength++;
                }
            });
            this.isIndeterminate =
                filteredLength > 0 &&
                filteredLength < this.filteredRouteAreaCache.length;
            this.isChecked =
                filteredLength > 0 &&
                filteredLength === this.filteredRouteAreaCache.length;
        }
    }



    private fetchLocationTwo(): void {
        this.locationtwo.findToComboBox().subscribe({
            next: (res) => {
                this.locationTwoList = res.data;
                this.filteredLocationTwo.next(this.locationTwoList);
                // listen for search field value changes
                this.locationTwoMultiFilterCtrl.valueChanges
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => {
                        this.filterLocationTwoMulti();
                        this.setToggleAllCheckboxStateLocationTwo();
                    });
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener localización.","Cerrar",{ duration: 5000});
            },
        });
    }


    protected filterLocationTwoMulti() {
        if (!this.locationTwoList) {
            return;
        }
        // get the search keyword
        let search = this.locationTwoMultiFilterCtrl.value;
        if (!search) {
            this.filteredLocationTwoCache = this.locationTwoList;
            this.filteredLocationTwo.next(this.locationTwoList);
            return;
        } else {
            search = search.toLowerCase();
        }
        // Filtrar las rutas por nombre o código
        this.filteredLocationTwoCache = this.locationTwoList.filter((material) => {
            const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
            const codeMatches =
                material?.code?.toLowerCase().indexOf(search) > -1;
            return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
        });
        this.filteredLocationTwo.next(this.filteredLocationTwoCache);
    }

    toggleSelectAllLocationTwo(selectAllValue: boolean) {
        this.filteredLocationTwo
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe((val) => {
                if (selectAllValue) {
                    this.locationTwoMultiCtrl.patchValue(val);
                } else {
                    this.locationTwoMultiCtrl.patchValue([]);
                }
            });
    }
    protected setToggleAllCheckboxStateLocationTwo() {
        let filteredLength = 0;
        if (this.locationTwoMultiCtrl && this.locationTwoMultiCtrl.value) {
            this.filteredLocationTwoCache.forEach((el) => {
                if (this.locationTwoMultiCtrl.value.indexOf(el) > -1) {
                    filteredLength++;
                }
            });
            this.isIndeterminateTwo =
                filteredLength > 0 &&
                filteredLength < this.filteredLocationTwoCache.length;
            this.isCheckedTwo =
                filteredLength > 0 &&
                filteredLength === this.filteredLocationTwoCache.length;
        }
    }


        private fetchSubRoute(): void {
        this.subRouteService.findToComboBox().subscribe({
            next: (res) => {
                this.subRouteList = res.data;
                this.filteredSubRoute.next(this.subRouteList);
                // listen for search field value changes
                this.subRouteMultiFilterCtrl.valueChanges
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe(() => {
                        this.filterSubRouteMulti();
                        this.setToggleAllCheckboxStateSubRoute();
                    });
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener rutas.","Cerrar",{ duration: 5000});
            },
        });
    }


    protected filterSubRouteMulti() {
        if (!this.subRouteList) {
            return;
        }
        // get the search keyword
        let search = this.subRouteMultiFilterCtrl.value;
        if (!search) {
            this.filteredSubRouteCache = this.subRouteList;
            this.filteredSubRoute.next(this.subRouteList);
            return;
        } else {
            search = search.toLowerCase();
        }
        // Filtrar las rutas por nombre o código
        this.filteredSubRouteCache = this.subRouteList.filter((material) => {
            const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
            const codeMatches =
                material?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
            return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
        });
        this.filteredSubRoute.next(this.filteredSubRouteCache);
    }

    toggleSelectAllSubRoute(selectAllValue: boolean) {
        this.filteredSubRoute
            .pipe(take(1), takeUntil(this._onDestroy))
            .subscribe((val) => {
                if (selectAllValue) {
                    this.subRouteMultiCtrl.patchValue(val);
                } else {
                    this.subRouteMultiCtrl.patchValue([]);
                }
            });
    }
    protected setToggleAllCheckboxStateSubRoute() {
        let filteredLength = 0;
        if (this.subRouteMultiCtrl && this.subRouteMultiCtrl.value) {
            this.filteredSubRouteCache.forEach((el) => {
                if (this.subRouteMultiCtrl.value.indexOf(el) > -1) {
                    filteredLength++;
                }
            });
            this.isIndeterminateSub =
                filteredLength > 0 &&
                filteredLength < this.filteredSubRouteCache.length;
            this.isCheckedSub =
                filteredLength > 0 &&
                filteredLength === this.filteredSubRouteCache.length;
        }
    }



    findAllWithCount(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.businessService
                .findAllForImportGeo(
                    {
                        currentPage: this.pageIndex,
                        limitPerPage: this.pageSize,
                        search: this.searchQuery,
                    },
                    this.routeMultiCtrl.value?.map((route) => route.id) ?? [],
                    this.routeAreaMultiCtrl.value?.map((routeArea) => routeArea.id) ?? [],
                    this.locationTwoMultiCtrl.value?.map((location) => location.code) ?? [],
                    this.subRouteMultiCtrl.value?.map((subRoute) => subRoute.id) ?? [],
                    this.businessPartners.value?.map((business) => business.id) ?? [],
                )
                .subscribe({
                    next: (data) => {
                        this.dataSource = data?.data?.[0]?.data ?? [];
                        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
                        resolve();
                    },
                    error: (err) => {
                        this.snackBar.open(err.error.message || "Error al obtener información de los socios de negocios.","Cerrar",{ duration: 5000});
                        reject(err);
                    }
                });
        });
    }


    async exportToExcel() {
        await this.findAllWithCount();
        if (this.totalItems > 0) {
            if (!this.businessPartnerAddressExport.canStartTask()) return;
            this.businessPartnerAddressExport.exportAllAddresses(
                ExportFileFormat.Excel,
                ExportRange.AllPages,
                this.totalItems,
                this.pageSize,
                this.pageIndex,
            );
        } else {
            this.snackBar.open("No hay datos para exportar", "Cerrar", {
                duration: 3000,
                panelClass: ["bg-red-500", "text-white"],
            });
        }
    }

    hasActiveFilters(): boolean {
        return this.businessPartners.value?.length > 0 ||
            this.routeMultiCtrl.value?.length > 0 ||
            this.routeAreaMultiCtrl.value?.length > 0 ||
            this.subRouteMultiCtrl.value?.length > 0 ||
            this.locationTwoMultiCtrl.value?.length > 0;
    }


}